// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Guatemala from '../_raw/flag/icon_flag_guatemala.png';

export default () => <img src={Guatemala} alt="Guatemala" />;
